import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00412 = new TileLayer({
  title: 'Máscara 19870903',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19870903l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00412.setVisible(false);

const layer00411 = new TileLayer({
  title: 'Máscara 19871122',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19871122l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00411.setVisible(false);

const layer00410 = new TileLayer({
  title: 'Máscara 19880109',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19880109l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00410.setVisible(false);

const layer00409 = new TileLayer({
  title: 'Máscara 19880226',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19880226l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00409.setVisible(false);

const layer00408 = new TileLayer({
  title: 'Máscara 19880414',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19880414l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00408.setVisible(false);

const layer00407 = new TileLayer({
  title: 'Máscara 19880430',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19880430l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00407.setVisible(false);

const layer00406 = new TileLayer({
  title: 'Máscara 19880601',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19880601l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00406.setVisible(false);

const layer00405 = new TileLayer({
  title: 'Máscara 19880804',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19880804l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00405.setVisible(false);

export const grupoCapa01_34 = new LayerGroup({
  title: 'Ciclo Hidrológico 1987-1988',
  fold: 'close',
  layers: [layer00405, layer00406, layer00407, layer00408, layer00409, layer00410, layer00411, layer00412]
});